import {Box} from "@mui/material";
import {useAppContext} from "@/contexts/AppContext.tsx";

export default function MainWrapper({children, ...props}: any) {
    const {uiVisual} = useAppContext();

    return (
        <Box sx={{p: {md: uiVisual === 'classic' ? 2 : 4, xs: 2}, mt: {md: 0, xs: 0}}} pb={0} width="100%" {...props}>
            {children}
        </Box>
    )
}